/**
 * @generated SignedSource<<6bcf99d031a880bc9a6636a234c036f5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Access = "APP" | "BOOK_DOC_AT_PARTNER" | "BOOK_DOC_AT_PHARMACY" | "INBOUND_CALL" | "OUTBOUND_CALL" | "PARTNER_PORTAL" | "WEBSITE" | "WEB_BOOKING";
export type AppointmentTagVariant = "ATTENTION" | "CRITICAL" | "MOST_CRITICAL" | "NEUTRAL" | "SUCCESS" | "WARNING";
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type FileUploadRequestStatus = "CANCELED" | "CLOSED" | "PENDING" | "UPLOADED";
export type FileUploadRequestType = "AFFECTED_AREA_NOT_VISIBLE" | "DOCUMENT_REQUIRED" | "INSUFFICIENT_QUALITY_OF_PHOTOS" | "PHOTOS_REQUIRED";
export type Flexibility = "FIXED_TIME" | "FLEXIBLE" | "NOT_EARLIER";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MedgateConnectOrderStatus = "CLOSED" | "FULFILLED" | "OPEN";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type Urgency = "MEDICAL_ACUTE" | "MEDICAL_URGENT" | "NORMAL";
import { FragmentRefs } from "relay-runtime";
export type appointmentRow_WaitingRoomAppointment$data = {
  readonly appointment: {
    readonly access: Access;
    readonly appointmentType: AppointmentType;
    readonly assignedTo: string | null;
    readonly channel: CommunicationChannel;
    readonly delay: number;
    readonly fileUploadRequest: {
      readonly createdAt: string;
      readonly createdBy: string;
      readonly status: FileUploadRequestStatus;
      readonly type: FileUploadRequestType;
    } | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly isPartnerInVideoCall: boolean;
    readonly language: Language;
    readonly medgateConnectOrder: {
      readonly status: MedgateConnectOrderStatus;
    } | null;
    readonly patient: {
      readonly patientFileLock: {
        readonly lockedBy: string | null;
      };
    };
    readonly reason: string;
    readonly service: Service;
    readonly specialty: ServiceSpecialty;
    readonly tags: ReadonlyArray<{
      readonly value: string;
      readonly variant: AppointmentTagVariant;
    }>;
    readonly urgency: Urgency;
    readonly " $fragmentSpreads": FragmentRefs<"appointmentStatusCell_appointment">;
  };
  readonly flexibility: Flexibility;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentServiceLevelAgreementFragment">;
  readonly " $fragmentType": "appointmentRow_WaitingRoomAppointment";
};
export type appointmentRow_WaitingRoomAppointment$key = {
  readonly " $data"?: appointmentRow_WaitingRoomAppointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentRow_WaitingRoomAppointment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentRow_WaitingRoomAppointment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flexibility",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "appointmentServiceLevelAgreementFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCompleted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPartnerInVideoCall",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "channel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urgency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignedTo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "access",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "service",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "specialty",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appointmentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AppointmentTag",
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "variant",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MedgateConnectOrder",
          "kind": "LinkedField",
          "name": "medgateConnectOrder",
          "plural": false,
          "selections": [
            (v1/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FileUploadRequest",
          "kind": "LinkedField",
          "name": "fileUploadRequest",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdBy",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "patient",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PatientFileLock",
              "kind": "LinkedField",
              "name": "patientFileLock",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lockedBy",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "appointmentStatusCell_appointment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomAppointment",
  "abstractKey": null
};
})();

(node as any).hash = "c7c7af8088b0b97e4df0378a349632bc";

export default node;
